module.exports = __webpack_public_path__ + "static/img/Team_Logo.737b599.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/phone/Team_Logo.png
// module id = /eDR
// module chunks = 1